/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

/**
 * @deprecated
 * @type {*|{}}
 */
var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для формы смены пароля.
   */
  app.UserChangePasswordView = app.View.extend({
    el: '#change-password-form',
    
    events: {
      'click #save-new-password': 'changePassword',
      'click #cancel-change-password': 'cancel'
    },
    
    run: function (options) {
      this.parent = options.parent;
      this.listenTo(this.parent, 'formPasswordToggle', this.passFormToggle);
      
      this.$el.find('.password').each(function () {
        new app.PasswordInputView({el: $(this)});
      });
    },
    
    passFormToggle: function () {
      this.toggle();
    },
    cancel: function () {
      this.toggle();
      this.parent.toggle();
    }
  });
})(jQuery);

}.call(window));